import React from 'react';
import { usePanelLabel } from '../primitives/labels';
import { ToolMenuProps } from './types';

function ToolMenu({
    tools,
    shortcutLabels,
    onSelect,
    style,
    renderMenuItem,
}: ToolMenuProps) {
    const t = usePanelLabel();
    const handleItemClick = (e: React.MouseEvent, toolId: string) => {
        e.stopPropagation();
        onSelect(toolId);
    };
    return (
        <div
            className="tool-menu"
            style={style}
            onMouseDown={(e) => e.stopPropagation()}
        >
            {tools.map((tool) => (
                <div
                    key={tool.id}
                    onClick={(e) => handleItemClick(e, tool.id)}
                    onKeyDown={(e) => {
                        if (e.key !== 'Enter' && e.key !== ' ') return;
                        e.preventDefault();
                        e.stopPropagation();
                        onSelect(tool.id);
                    }}
                    role="menuitem"
                    tabIndex={0}
                    className="tool-menu-item focus-ring"
                >
                    {renderMenuItem ? (
                        renderMenuItem(tool)
                    ) : (
                        <>
                            <tool.icon className="tool-menu-icon toolbar-icon w-5 h-5 mr-2" />
                            <span>
                                {t(`tools.${tool.id}`,
                                    tool.name.split(' Tool')[0],
                                )}
                                {shortcutLabels && shortcutLabels[tool.id]
                                    ? ` (${shortcutLabels[tool.id]})`
                                    : ''}
                            </span>
                        </>
                    )}                </div>
            ))}
        </div>
    );
}

export default ToolMenu;
